import { render, staticRenderFns } from "./noteSendList.vue?vue&type=template&id=31ffa1d9&scoped=true&"
import script from "./noteSendList.vue?vue&type=script&lang=js&"
export * from "./noteSendList.vue?vue&type=script&lang=js&"
import style0 from "./noteSendList.vue?vue&type=style&index=0&id=31ffa1d9&prod&scoped=true&lang=css&"
import style1 from "./noteSendList.vue?vue&type=style&index=1&id=31ffa1d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ffa1d9",
  null
  
)

export default component.exports